var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { deleteProperty, patchProperty, postProperty, } from "../../resources/helper/properties";
/**
 * POST / PATCH / DELETE de /V1/Properties.
 *
 * Ninguna mutación toca la lista: la página no mantiene estado optimista, así
 * que el contenedor recarga el listado después de cada operación exitosa.
 * `property.id` es obligatorio para PATCH y DELETE.
 */
export var usePropertiesMutations = function () {
    var _a = useState(false), loadingPropertyMutation = _a[0], setLoadingPropertyMutation = _a[1];
    var _b = useState(null), responsePropertyMutation = _b[0], setResponsePropertyMutation = _b[1];
    var _c = useState(null), errorPropertyMutation = _c[0], setErrorPropertyMutation = _c[1];
    var run = function (mutation, call) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingPropertyMutation(true);
                    setErrorPropertyMutation(null);
                    setResponsePropertyMutation(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, call()];
                case 2:
                    _a.sent();
                    setResponsePropertyMutation(mutation);
                    return [2 /*return*/, true];
                case 3:
                    error_1 = _a.sent();
                    setErrorPropertyMutation(error_1);
                    return [2 /*return*/, false];
                case 4:
                    setLoadingPropertyMutation(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var createProperty = function (payload) {
        return run("create", function () { return postProperty({ data: payload }); });
    };
    var updateProperty = function (property, payload) {
        if (!property.id) {
            setErrorPropertyMutation({
                errors: [{ code: "MISSING_ID", message: "PROPERTY_ID_REQUIRED" }],
            });
            return Promise.resolve(false);
        }
        return run("update", function () { return patchProperty(property.id, { data: payload }); });
    };
    var removeProperty = function (property) {
        if (!property.id) {
            setErrorPropertyMutation({
                errors: [{ code: "MISSING_ID", message: "PROPERTY_ID_REQUIRED" }],
            });
            return Promise.resolve(false);
        }
        return run("delete", function () { return deleteProperty(property.id); });
    };
    var clearPropertyMutation = function () {
        setResponsePropertyMutation(null);
        setErrorPropertyMutation(null);
    };
    return {
        createProperty: createProperty,
        updateProperty: updateProperty,
        removeProperty: removeProperty,
        clearPropertyMutation: clearPropertyMutation,
        loadingPropertyMutation: loadingPropertyMutation,
        responsePropertyMutation: responsePropertyMutation,
        errorPropertyMutation: errorPropertyMutation,
    };
};
